import { occBaseSiteUrl, occFetch } from "~/app/api/occ/occFetch";
import { occCartUserPath, type OccCartUserPath } from "~/app/api/occ/occUserPath";
import { userIsCustomer } from "~/domains/user/utils/roles";
import { resolveActiveCartResourceId } from "~/features/cart/cart/utils/cartResourceIdentity";

interface ClearSalesPartnerContext {
  activeCartId: string | undefined;
  customer: boolean;
  userPath: OccCartUserPath;
}

export function resolveClearSalesPartnerUrl(activeCartId: string, userPath: OccCartUserPath): string {
  return occBaseSiteUrl(`${userPath}/carts/${encodeURIComponent(activeCartId)}/sales-partner`);
}

export async function clearSalesPartnerForActiveB2CCart(context?: ClearSalesPartnerContext): Promise<void> {
  if (!context) {
    if (userIsCustomer()) {
      return;
    }
    context = {
      activeCartId: await resolveActiveCartResourceId(),
      customer: false,
      userPath: occCartUserPath(),
    };
  }

  const { activeCartId, customer, userPath } = context;
  if (customer || !activeCartId) {
    return;
  }

  const response = await occFetch(resolveClearSalesPartnerUrl(activeCartId, userPath), {
    method: "DELETE",
  });
  if (!response.ok) {
    throw new Error(`Could not clear Cart sales partner: ${response.status}`);
  }
}
